<template>
    <c-col :lg="lg" :md="md" :sm="sm" :xl="xl" :xs="xs" :xxl="xxl">
        <slot />
    </c-col>
</template>
<script setup>
import { CCol } from '@coreui/vue/dist/esm/components/grid/index.js';

const props = defineProps({
    xxl: [Number, String, Boolean],
    xl: [Number, String, Boolean],
    lg: [Number, String, Boolean],
    md: [Number, String, Boolean],
    sm: [Number, String, Boolean],
    xs: [Number, String, Boolean],
});
</script>
